import { formatInTimeZone } from 'date-fns-tz';
import type { AvailabilitySlot } from '@agenda-facil/contracts';

export type AvailabilityPeriod = 'MORNING' | 'AFTERNOON' | 'EVENING';

export interface AvailabilityOption {
  time: string;
  slot?: AvailabilitySlot;
}

export interface AvailabilityGroup {
  id: AvailabilityPeriod;
  label: string;
  options: AvailabilityOption[];
}

const periods: Array<{
  id: AvailabilityPeriod;
  label: string;
  startMinute: number;
  endMinute: number;
}> = [
  { id: 'MORNING', label: 'Manhã', startMinute: 0, endMinute: 12 * 60 },
  { id: 'AFTERNOON', label: 'Tarde', startMinute: 12 * 60, endMinute: 18 * 60 },
  { id: 'EVENING', label: 'Noite', startMinute: 18 * 60, endMinute: 24 * 60 },
];

function toMinute(time: string): number {
  const [hour = 0, minute = 0] = time.split(':').map(Number);
  return hour * 60 + minute;
}

function toClock(minute: number): string {
  return `${Math.floor(minute / 60)
    .toString()
    .padStart(2, '0')}:${(minute % 60).toString().padStart(2, '0')}`;
}

export function buildAvailabilityGroups(
  slots: AvailabilitySlot[],
  timezone: string,
): AvailabilityGroup[] {
  const slotsByMinute = new Map<number, AvailabilitySlot>();
  for (const slot of slots) {
    const time = formatInTimeZone(slot.startsAt, timezone, 'HH:mm');
    slotsByMinute.set(toMinute(time), slot);
  }

  return periods.map((period) => {
    const availableMinutes = [...slotsByMinute.keys()].filter(
      (minute) => minute >= period.startMinute && minute < period.endMinute,
    );
    if (availableMinutes.length === 0) return { id: period.id, label: period.label, options: [] };

    const firstMinute = Math.min(...availableMinutes);
    const lastMinute = Math.max(...availableMinutes);
    const options: AvailabilityOption[] = [];
    for (let minute = firstMinute; minute <= lastMinute; minute += 15) {
      options.push({ time: toClock(minute), slot: slotsByMinute.get(minute) });
    }
    return { id: period.id, label: period.label, options };
  });
}
